// import '@babel/polyfill'
// import 'core-js/stable'
// import 'regenerator-runtime/runtime'

import Vue from 'vue'
import store from './store'
import App from './App.vue'
import router from './router'
import { i18n, resx } from './resx'

import VueHead from 'vue-head'
// import VueAnalytics from 'vue-analytics'

import SimpleAnalytics from 'simple-analytics-vue'
import { initAppInsights, appInsights } from './insights'

import viabase from 'via-base'

import './styles/bulma.sass'
import './styles/global.scss'
// import 'leaflet/dist/leaflet.css'

import 'maplibre-gl/dist/maplibre-gl.css'

import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import contactform from '@/components/custom/Contactform.vue'
import staff from '@/components/custom/Staff.vue'
import partners from '@/components/custom/Partners.vue'
import contentMap from '@/components/custom/Map.vue'
import contentChartsTop from '@/components/custom/ChartsTop.vue'
import contentChartsBottom from '@/components/custom/ChartsBottom.vue'
import library from '@/components/custom/Library.vue'
import downloadsList from '@/components/custom/DownloadsList.vue'
import starApp from '@/components/custom/StarApp.vue'
import starFooter from '@/components/custom/StarFooter.vue'
import starPartner from '@/components/custom/StarPartner.vue'
import space from '@/components/custom/Space.vue'

import filters from '@/filters/filters'

filters.forEach(f => {
  Vue.filter(f.name, f.execute)
})

initAppInsights()

Vue.config.errorHandler = function (err, vm, info) {
  appInsights.trackException({
    exception: err,
    customProperties: {
      error: err,
      vm: vm,
      info: info
    }
  })
}

Vue.use(viabase)

Vue.component('contactform', contactform)
Vue.component('staff', staff)
Vue.component('partners', partners)
Vue.component('contentMap', contentMap)
Vue.component('contentChartsTop', contentChartsTop)
Vue.component('contentChartsBottom', contentChartsBottom)
Vue.component('library', library)
Vue.component('downloadsList', downloadsList)
Vue.component('starApp', starApp)
Vue.component('starFooter', starFooter)
Vue.component('starPartner', starPartner)
Vue.component('space', space)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.config.devtools = false

var VueCookie = require('vue-cookie')
Vue.use(VueCookie)
Vue.use(resx, store.state.isAdmin)
Vue.use(VueHead)

if (window.Element && !Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s)
    var i
    var el = this
    do {
      i = matches.length
      while (--i >= 0 && matches.item(i) !== el) {};
    } while ((i < 0) && (el = el.parentElement))
    return el
  }
}
HTMLElement.prototype.removeClass = function (remove) {
  var newClassName = ''
  var i
  var classes = this.className.split(' ')
  for (i = 0; i < classes.length; i++) {
    if (classes[i] !== remove) {
      newClassName += classes[i] + ' '
    }
  }
  this.className = newClassName
}

if (!String.prototype.startsWith) {
  // eslint-disable-next-line
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0
    return this.indexOf(searchString, position) === position
  }
}

Vue.use(SimpleAnalytics, { skip: process.env.NODE_ENV !== 'production', domain: 'sa.' + window.location.host })

Vue.directive('tooltip', {
  inserted: function (el) {
    var bodyWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    if (bodyWidth < 1344) {
      var rect = el.getBoundingClientRect()
      if (rect.left > (bodyWidth * 0.75)) {
        el.removeClass('has-tooltip-right')
        el.className = el.className + ' has-tooltip-left'
      } else if (rect.left > (bodyWidth * 0.25)) {
        el.removeClass('has-tooltip-right')
        el.className = el.className + ' has-tooltip-bottom'
      }
    }
  }
})
Vue.filter('upperfirst', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

new Vue({
  viabase,
  router,
  i18n,
  resx,
  store,
  render: h => h(App)
}).$mount('#app')
